import { DatePickerUnstyled } from 'Components/Form/DatePicker/unstyled'
import styled from 'styled-components'

export const DatePicker = styled(DatePickerUnstyled)`
  position: relative;

  input {
    position: relative;
    width: 100%;
    border-radius: 4px;
    height: 52px;
    background: ${props => props.theme.colors.alabaster};
    border: none;
    padding: ${props => (props.icon ? '0 20px 0 54px' : '0 20px')};
    color: ${props => props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.form.input};
    outline: none;

    ::placeholder {
      font-size: ${props => props.theme.fontSizes.form.placeholder};
      color: ${props => props.theme.colors.placeholder};
      letter-spacing: 0.6px;
    }
  }

  hr {
    display: none;
  }

  .icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 23px;
    right: auto;
    margin: auto;
  }

  .label {
    display: block;
    padding: 0;
    text-align: left;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/DatePicker/index.js